import { useMemo } from 'react';

/**
 * Platform-agnostic hook for managing profile image URL and error handling.
 * Generates profile image URL with cache busting and provides error fallback.
 */
export function useProfileImageHandling(userId: string | undefined) {
  const profileImageUrl = useMemo(() => {
    if (!userId) return '/default-profile-picture.jpg';
    return `https://media.${
      process.env.REACT_APP_HOST
    }/users/${userId}-thumbnail.jpg?v=${Date.now()}`;
  }, [userId]);

  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = '/default-profile-picture.jpg';
  };

  return {
    profileImageUrl,
    handleImageError,
  };
}
